module.exports = __webpack_public_path__ + "img/CellCycle-OVCA_10X_OC.f5e7bbbd.png";